import { trans } from '@spotahome/soyuz/client';

import Link from '../Link';

import { useModalHandle } from '../utils/withModalHandle';

import LongTermModal from './LongTermModal';

const LongTermDescription = () => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle({
    removeScrollbarCSL: true
  });

  const handleOnClick = e => {
    e.preventDefault();
    handleModalOpen();
  };

  return (
    <>
      {trans('listing.labels.long.term.description')}{' '}
      <strong>
        <Link
          onClick={handleOnClick}
          data-test="long-term-see-more-open"
          size="medium"
          theme="dark"
        >
          {trans('listing.labels.long.term.see-more')}
        </Link>
      </strong>
      <LongTermModal isOpen={isModalOpen} handleClose={handleModalClose} />
    </>
  );
};

export default LongTermDescription;
